import { ModalProvider } from '@/context/modal'
import { OnLoadAction } from '@/shared/api-generated-types'
import DialogAction from '@/widgets/DialogAction'
import PartnerSwitchDialog from '@/widgets/PartnerSwitchDialog'

export const HandleOnLoadAction = (action: OnLoadAction): JSX.Element | null => {
  if (action?.__typename === 'Dialog') {
    const dialog = action
    switch (dialog.id) {
      case 'partner-switch':
        return <PartnerSwitchDialog isOpen={true} />

      default:
        return (
          <ModalProvider initialState={{ isOpen: true }}>
            <DialogAction staticDialog={dialog} />
          </ModalProvider>
        )
    }
  }

  return null
}
